import * as React from 'react';

import type { TabLayoutProps } from '@/components/pages/event/types/TabLayout';
import SectionPastAttendees from '@/components/pages/event/layout/components/SectionPastAttendees';
import { Content } from '@/types/EventsCustomFields';

type PastAttendeesLayoutProps = TabLayoutProps & {
    pastAttendees: Content | null;
};

const PastAttendeesLayout = (props: PastAttendeesLayoutProps) => {
    const { event, accentColor, pastAttendees } = props;

    return (
        <div className="p-5 md:p-10 xl:px-20 md:pr-32 xl:pr-32 pb-96">
            <div>
                {pastAttendees && (
                    <SectionPastAttendees
                        eventSlug={event.slug}
                        pastAttendees={pastAttendees}
                        accentColor={accentColor}
                        showAllLink={false}
                    />
                )}
            </div>
        </div>
    );
};

export default PastAttendeesLayout;
